/**
 * 歳出款項目（Expenditure Category）のCascaderオプション構築
 *
 * 階層: 款（kan）→ 項（ko）→ 目（moku）
 */

import type { CascaderOption } from '@/shared/ui';
import type { ConvertResultExpenditurePurposeOption } from '../api/generated/model';
import {
  buildHierarchicalCascaderOptions,
  codeNameLevel,
} from './buildHierarchicalCascaderOptions';

/**
 * 歳出款項目のフラットデータからCascaderオプションを構築
 *
 * @param purposes - 歳出款項目の生データ
 * @param selectedAccountingTypeCode - 会計区分コード（指定時はその会計区分に属する款のみ表示）
 */
export const buildExpenditureCategoryCascaderOptions = (
  purposes: ConvertResultExpenditurePurposeOption[] | null | undefined,
  selectedAccountingTypeCode: string | null,
): CascaderOption[] =>
  buildHierarchicalCascaderOptions({
    items: purposes,
    levels: [
      {
        ...codeNameLevel<ConvertResultExpenditurePurposeOption>({
          getCode: (p) => p.kan_code,
          getName: (p) => p.kan_name,
        }),
        getGroupKey: (p) => `${p.parent_accounting_type_code}_${p.kan_code}`,
      },
      codeNameLevel<ConvertResultExpenditurePurposeOption>({
        getCode: (p) => p.ko_code,
        getName: (p) => p.ko_name,
      }),
      codeNameLevel<ConvertResultExpenditurePurposeOption>({
        getCode: (p) => p.moku_code,
        getName: (p) => p.moku_name,
      }),
    ],
    preFilter: selectedAccountingTypeCode
      ? (p) => p.parent_accounting_type_code === selectedAccountingTypeCode
      : undefined,
  });
